"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTicketingCreatedMockData = void 0;
const ticketing_1 = require("../../enums/ticketing");
const email_theme_tokens_1 = require("../../helpers/email-theme-tokens");
const email_templates_1 = require("../../internationalization/locales/email-templates");
const subject_templates_1 = require("./subject-templates");
const buildTicketingCreatedMockData = ({ orgName = "Bright Futures Foundation", formTitle = "Spring Gala 2026", firstName = "John", formCategory = ticketing_1.TicketingFormCategory.Event, showBankAccountNote = true, formUrl = "https://www.zeffy.com/en-US/ticketing/spring-gala-2026", bankAccountUrl = "https://www.zeffy.com/dashboard/settings/bank-account", locale = "en", subject = (0, subject_templates_1.buildTicketingCreatedSubject)(locale, formTitle), } = {}) => {
    return {
        labels: (0, email_templates_1.getEmailLabels)(locale),
        theme: (0, email_theme_tokens_1.getOrgFacingEmailTheme)(),
        currentYear: new Date().getFullYear(),
        lang: locale,
        subject,
        isPreview: false,
        formCategory,
        orgName,
        formTitle,
        firstName,
        showBankAccountNote,
        formUrl,
        bankAccountUrl,
    };
};
exports.buildTicketingCreatedMockData = buildTicketingCreatedMockData;
